import type { Page } from '@ps/web-martech-cms-types';
import { ContentType } from '@ps/web-martech-cms-types';
import type { CoreWidgetBlock } from '@ps/web-martech-cms-types/Main';

import type { PageResponse } from '@swf/core/models/cms';

enum CashierWidgetType {
  FirstWallet = 'first_wallet'
}

export const CASHIER_PAGE_RESPONSE = {
  content: {
    firstWalletWidget: {
      title: 'First Wallet Widget',
      uid: 'firstWalletWidget',
      _content_type_uid: CashierWidgetType.FirstWallet
    },
    'cashier-section-main': {
      _content_type_uid: 'main',
      title: 'Cashier Main Section',
      uid: 'cashier-section-main',
      body: [
        {
          core_widget: {
            reference: [
              {
                uid: 'firstWalletWidget',
                _content_type_uid: CashierWidgetType.FirstWallet
              }
            ]
          }
        }
      ] as unknown as CoreWidgetBlock[]
    },
    'cashier-section-seo': {
      _content_type_uid: 'seo',
      title: 'Cashier',
      uid: 'cashier-section-seo',
      meta: {
        description: 'Cashier Home',
        robots: {
          noindex: true,
          nofollow: true
        }
      },
      non_translatable: false
    }
  },
  page: {
    alias: 'firstWalletHome',
    uid: 'firstWalletHome',
    additional_resources: [],
    casino_search: [],
    content: [
      {
        left: [],
        main: [{ uid: 'cashier-section-main', _content_type_uid: ContentType.Main }],
        seo: [{ uid: 'cashier-section-seo', _content_type_uid: ContentType.SEO }],
        side: [],
        top: [],
        header_link: [],
        shared: true,
        suppress_marketing_notifications: false,
        website: []
      }
    ],
    layout: {
      layout_type: 'StarsLayout',
      background_color: '#151515',
      background_fit: 'fixed'
    } as unknown as Page['layout'],
    title: 'PokerStars Cashier',
    url: '/cashier/',
    _content_type_uid: 'page',
    enable_optimizely: false,
    hide_navigation: false,
    visible_in_sitemap: false
  }
} as PageResponse;
